module.exports = __webpack_public_path__ + "img/CivsListBG.6c166005.webp";